<template>
  <div>
    <div class="d-md-none d-block pos-fixed b-0 l-0 wd-100p pd-10">
      <button @click="$emit('on-view-lessons')" class="btn btn-block btn-primary">Хичээлүүд</button>
    </div>
    <!-- <vue-custom-scrollbar :style="`height: ${getScrollHeight()}`"> -->
    <div v-if="$store.state.app.activeGroup.learnConfig!=undefined && $store.state.app.activeGroup.learnConfig.course.showAlert">
      <div v-for="(alert, i) in obj.alerts" :key="i + '_alert'">
        <template v-if="alert.hasLink">
          <router-link
            v-if="
              (alert.type == 503 && obj.percent == 100) || alert.type != 503
            "
            :to="alert.rawLink"
          >
            <div
              :class="`alert alert-${alert.color} d-flex align-items-center`"
              role="alert"
            >
              <feather
                :type="alert.featherIcon"
                class="mg-r-10"
                style="min-width: 16px"
              ></feather>
              <div>
                {{ alert.msg }}
              </div>
              <div class="mg-l-auto">
                <button :class="`btn btn-outline-${alert.color} btn-xs d-flex`">
                  үзэх<feather
                    type="arrow-right"
                    class="mg-l-5"
                    size="14"
                  ></feather>
                </button>
              </div>
            </div>
          </router-link>
        </template>
        <template v-else>
          <div
            :class="`alert alert-${alert.color} d-flex align-items-center`"
            role="alert"
          >
            <feather :type="alert.featherIcon" class="mg-r-10"></feather>
            {{ alert.msg }}
          </div>
        </template>
      </div>
    </div>
    <!-- <div v-html="obj.info" class="tx-13 tx-color-02" ></div> -->
    <!-- <video
      :loop="true"
      :muted="true"
      v-if="obj.videoCover != ''"
      controls
      controlslist="nodownload"
      autoplay
      class="mx-wd-100p"
    >
      <source :src="obj.videoCover" type="video/mp4" />
    </video>
    <div v-else class="container text-center">
      <img :src="`${obj.cover}?w=600&h=300&mode=crop`" class="rounded-20 mx-wd-100p" />
    </div> -->
<!-- {{obj}} -->
    <ul class="nav-top nav nav-justified">
      <li class="nav-item">
        <a
          @click="changeTab(1)"
          class="nav-link"
          role="button"
          :class="{ active: activeTab == 1 }"
          >Тухай</a
        >
      </li>
      <li class="nav-item" v-if="($store.state.app.activeGroup.id==9241 || $store.state.app.activeGroup.id==9249)">
        <a @click="changeTab(11)" class="nav-link" role="button" :class="{ active: activeTab == 11 }" >Төлөвлөх</a>
      </li>
      <li class="nav-item" v-if="obj.i6 != undefined && obj.i6==1">
        <a :class="{ active: $route.params.bot == -7 && activeTab==null }" @click="activeTab= null; $router.push({ name: 'lmsLessonView', params: { id: $route.params.id , cid: obj.id, bid: 0, iid: 0, bot: -7 } })" class="nav-link" role="button">
          Сертификат
         </a>
      </li>
      <li class="nav-item">
        <a @click="changeTab(2)" class="nav-link" role="button" :class="{ active: activeTab == 2 }">
          Шалгалт
          <span v-if="obj.boxes!=undefined && obj.boxes.length && obj.boxes.filter(x => x.ot == 116 && x.forms.length).length > 0 || obj.lessonExamCount > 0" class="badge badge-light mg-l-5">
            {{
              obj.boxes.filter(x => x.ot == 116 && x.forms.length).length > 0
                ? obj.boxes.filter(x => x.ot == 116 && x.forms.length)[0].forms
                    .length + obj.lessonExamCount
                : obj.lessonExamCount
            }}
          </span>
        </a>
      </li>
      <li class="nav-item">
        <a @click="changeTab(3)" class="nav-link" role="button" :class="{ active: activeTab == 3 }" >Хэлэлцүүлэг
          <span v-if="obj.boxes!=undefined && obj.boxes.length && obj.boxes.filter(x => x.ot == 124 && x.tasks.length).length > 0" class="badge badge-light mg-l-5" >
            {{obj.boxes.filter(x => x.ot == 124 && x.tasks.length)[0].tasks.length}}
          </span>
        </a>
      </li>
      <li class="nav-item">
        <a @click="changeTab(4)" class="nav-link" role="button" :class="{ active: activeTab == 4 }" >
          <div class=" d-flex align-items-center">
            Лайв сургалт
            <div v-if="hasActiveZoom()" class="bd bd-1 bd-danger rounded tx-11 tx-rubik pd-x-5-f pd-y-1-f mg-l-5 tx-danger">
              <feather type="wifi" class="ht-10-f wd-10-f tx-danger"></feather>
              LIVE
            </div>
          </div>
        </a>
      </li>
      <li class="nav-item">
        <a @click="changeTab(5)" class="nav-link" role="button" :class="{ active: activeTab == 5 }">Бие даалт
          <div v-if="obj.boxes!=undefined && obj.boxes.length && obj.boxes.filter(x => x.ot == 502 && x.tasks.length).length > 0 || obj.lessonWorkTestCount > 0" class="badge badge-light mg-l-5" >
            {{
              obj.boxes.filter(x => x.ot == 502).length > 0 ? obj.boxes.filter(x => x.ot == 502).length + obj.lessonWorkTestCount : obj.lessonWorkTestCount
            }}
          </div>
        </a>
      </li>
    </ul>
    
    <!-- <ul
      v-if="!$store.state.app.isMobile"
      class="nav nav-justified nav-line mg-t-10 mg-b-20"
    >
      
    </ul>
    <div v-else class="divider-text">Сургалтын агуулга</div> -->

    <!-- {{ activeTab }} -->

    <course-certificate v-if="$route.params.bot == -7 && activeTab==null" :cid="parseInt($route.params.cid, 10)"
      :style="`height: ${getScrollHeight()}`" @cert-err="activeTab=1"></course-certificate>
    <div v-if="activeTab!=null" :style="{ 'min-height': $store.state.app.isMobile ? '0' : '600px' }">
      <div
        v-if="activeTab == 1"
        :style="{ padding: $store.state.app.isMobile ? '0px 10px' : 'inherit' }"
      >
        <div class="d-flex mg-b-20">
          <div class="">
            <h6 class="tx-13 tx-inverse tx-semibold mg-b-5">
              Төрөл: <span class="tx-rubik" v-if="obj.locType!=undefined && obj.locType!=null">{{ obj.locType.name }}</span>
            </h6>
            <div class="text-muted tx-12" v-if="obj.date!=undefined && obj.date!=null">
              Үргэлжлэх хугацаа: {{ obj.date.start | moment("YYYY.MM.DD") }} -
              {{ obj.date.end | moment("YYYY.MM.DD") }}
            </div>
          </div>
          
          <div
            v-if="!$store.state.app.isMobile"
            class="mg-l-auto btn-group"
            role="group"
            aria-label="Basic example"
          >
            <button
              @click="showCourseSurvey(389, obj.boxes.filter(x => x.ot == 389 && x.forms.length)[0])"
              v-if="
              obj.boxes!=undefined && obj.boxes.length && obj.boxes.filter(x => x.ot == 389 && x.forms.length).length > 0
              "
              type="button"
              class="btn btn-outline-primary"
            >
              <feather
                type="check-circle"
                class="wd-15-f ht-15-f mg-r-5"
              ></feather>
              Энд дарж судалгаа бөглөнө үү
            </button>
            <button
              @click="showCourseSurvey(503, obj.boxes.filter(x => x.ot == 503 && x.forms.length)[0])"
              v-if="
              obj.boxes!=undefined && obj.boxes.length && obj.boxes.filter(x => x.ot == 503 && x.forms.length).length > 0
              "
              type="button"
              class="btn btn-outline-primary"
            >
              <feather type="star" class="wd-15-f ht-15-f mg-r-5"></feather>
              Энд дарж үнэлгээ өгнө үү
            </button>
          </div>
        </div>

        <div v-if="$store.state.app.isMobile" class="btn-group mg-b-10">
          <button
              @click="showCourseSurvey(389, obj.boxes.filter(x => x.ot == 389 && x.forms.length)[0])"
              v-if="
              obj.boxes!=undefined && obj.boxes.length && obj.boxes.filter(x => x.ot == 389 && x.forms.length).length > 0
              "
              type="button"
              class="btn btn-outline-primary"
            >
              Судалгаа бөглөх
            </button>
            <button
              @click="showCourseSurvey(503, obj.boxes.filter(x => x.ot == 503 && x.forms.length)[0])"
              v-if="
              obj.boxes!=undefined && obj.boxes.length && obj.boxes.filter(x => x.ot == 503 && x.forms.length).length > 0
              "
              type="button"
              class="btn btn-outline-primary"
            >
              Үнэлгээ өгөх
            </button>
        </div>

        <div v-html="obj.info" class="tx-13 tx-color-02 gosm-edtr-outer"></div>
      </div>
      <div v-if="activeTab == 2" class="tx-13 tx-color-02">
        <template
          v-if="obj.boxes!=undefined && obj.boxes.length && obj.boxes.filter(x => x.ot == 116 && x.forms.length).length > 0"
        >
          <form-list
            v-for="(b, i) in obj.boxes.filter(
              x => x.ot == 116 && x.forms.length
            )"
            :forms="b.forms"
            :box="b"
            :course="obj"
            :key="i"
            @on-show-exam-result="$emit('on-show-exam-result', $event)"
            backTo="course"
          />
        </template>
        <template v-else>
          <div
            class="alert alert-warning alert-dismissible fade show"
            role="alert"
          >
            <strong>Одоогоор шалгалт зарлагдаагүй байна.</strong>
          </div>
        </template>

        <template v-if="obj.hasLessonExam">
          <div class="divider-text">Явцын шалгалт</div>
          <div
            v-for="(lb, lbi) in obj.boxes.filter(
              x => x.ot == 114 && x.tasks.length
            )"
            :key="lbi"
          >
            <div v-for="(l, li) in lb.tasks" :key="li">
              <form-list
                v-for="(b, ibi) in l.boxes.filter(
                  x => x.ot == 416 && x.forms.length
                )"
                :forms="b.forms.filter(x => x.flag == 500)"
                :box="{ nm: 'Хичээл: ' + l.task, id: b.id, ot: b.ot }"
                :lid="l.id"
                :course="obj"
                backTo="courseHome"
                :key="ibi"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="alert alert-warning alert-dismissible fade show"
            role="alert"
          >
            <strong>Одоогоор хичээлийн шалгалт зарлагдаагүй байна.</strong>
          </div>
        </template>
      </div>
      <div v-if="activeTab == 3" class="tx-13 tx-color-02">
        <template
          v-if="obj.boxes.filter(x => x.ot == 124 && x.tasks.length).length > 0"
        >
          <forum-list
            v-for="(b, i) in obj.boxes.filter(
              x => x.ot == 124 && x.tasks.length
            )"
            :tasks="b.tasks"
            :box="b"
            :b="b"
            :key="i"
            @on-detail="$emit('on-detail', { event: $event, box: b })"
          />
        </template>
        <template v-else>
          <div class="container d-flex justify-content-center ht-100p">
            <div
              class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
            >
              <div class="wd-80p wd-sm-300 mg-b-15">
                <img src="assets/svg/boxempty.svg" alt="" class="img-fluid" />
              </div>
              <h4 class="tx-20 tx-sm-24 text-muted">
                Хэлэлцүүлэг эхлээгүй байна
              </h4>
            </div>
          </div>
        </template>
      </div>
      <div v-if="activeTab == 4" class="tx-13 tx-color-02">
        <!-- {{obj.boxes}} -->
        <template
          v-if="
            obj.boxes.filter(
              x => (x.ot == 493 || x.ot == 500 || x.ot == 516) && x.tasks.length
            ).length > 0
          "
        >
          <zoom-list
            v-for="(b, i) in obj.boxes.filter(
              x => (x.ot == 493 || x.ot == 500 || x.ot == 516) && x.tasks.length
            )"
            :tasks="b.tasks"
            :course="obj"
            :box="b"
            :b="b"
            :key="i"
            backTo="course"
            @on-detail="$emit('on-detail', { event: $event, box: b })"
          />
        </template>
        <template v-else>
          <div class="container d-flex justify-content-center ht-100p">
            <div
              class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
            >
              <div class="wd-80p wd-sm-300 mg-b-15">
                <img src="assets/svg/boxempty.svg" alt="" class="img-fluid" />
              </div>
              <h4 class="tx-20 tx-sm-24 text-muted">
                Онлайн сургалт зарлагдаагүй байна
              </h4>
            </div>
          </div>
        </template>
      </div>
      <div v-if="activeTab == 5" class="tx-13 tx-color-02">
        <template v-if="obj.boxes.filter(x => x.ot == 502).length > 0">
          <assign-list
            v-for="(b, i) in obj.boxes.filter(x => x.ot == 502)"
            :course="obj"
            :b="b"
            :key="i"
            backTo="course"
            @on-detail="$emit('on-detail', { event: $event, box: b })"
            @show-attach="$emit('show-attach', $event)"
          />
        </template>
        <template v-else>
          <div
            class="alert alert-warning alert-dismissible fade show"
            role="alert"
          >
            <strong>Бие даалт байхгүй байна !</strong>
          </div>
        </template>

        <template v-if="obj.hasLessonWorkTest">
          <div class="divider-text">Дасгал ажил</div>
          <div
            v-for="(lb, lbi) in obj.boxes.filter(
              x => x.ot == 114 && x.tasks.length
            )"
            :key="lbi"
          >
            <div v-for="(l, li) in lb.tasks" :key="li">
              <form-list
                v-for="(b, ibi) in l.boxes.filter(
                  x => x.ot == 117  && (x.forms!=undefined && x.forms.length)
                )"
                :forms="b.forms.filter(x => x.flag == 800)"
                :box="{ nm: 'Хичээл: ' + l.task, id: b.id, ot: b.ot }"
                :lid="l.id"
                :course="obj"
                backTo="courseHome"
                :key="ibi"
              />
            </div>
          </div>
        </template>
        <template v-else>
          <div
            class="alert alert-warning alert-dismissible fade show"
            role="alert"
          >
            <strong>Одоогоор дасгал ажил үүсгээгүй байна.</strong>
          </div>
        </template>
      </div>
      <div v-else-if="activeTab==11" class="pd-20 bd bd-1 rounded-10">
        <div class="font-weight-bold tx-18">
          Миний сургалтын төлөвлөгөө
        </div>
        <div>
          Хувийн сургалтын төлөвлөгөөгөө зохиосон суралцагчид сургалтаа дуусгах магадлал <b class="tx-primary">75%</b>-иар илүү байдаг. Бид таны хувийн сургалтын төлөвлөгөөг удирдахад тань туслах болно.  
        </div>
        <div class="text-center">
          <button @click="planModal= true" class="btn btn-primary">
            <span class="pd-x-50">Төлөвлөх</span>
            <feather type="arrow-right"></feather>
          </button>
        </div>
      </div>
    </div>

    

    <!-- <div class="mg-b-40" v-for="(b,i) in obj.boxes" :key="i+'_boxes'">
        <h4 v-if="(b.tasks.length || b.ot==502) || b.attaches.length || b.forms.length" class="mg-b-15 mg-lg-b-10 tx-color-02 bd-b bd-5 pd-b-5">{{b.nm}}</h4>
        <div v-if="b.tasks.length">
          <teacher-list
            v-if="b.ot==396"
            :tasks="obj.teachers"
            @on-detail="$emit('on-detail',  {event: $event, box: b})"
          />
          <lesson-list
            v-else-if="b.ot==114"
            :tasks="b.tasks"
            @on-detail="$emit('on-detail', $event)"
          />
          <forum-list
            v-else-if="b.ot==124"
            :tasks="b.tasks"
            @on-detail="$emit('on-detail', {event: $event, box: b})"
          />

          <zoom-list
            v-else-if="b.ot==500"
            :tasks="b.tasks" :course="obj"
            @on-detail="$emit('on-detail', {event: $event, box: b})"
          />
        </div>
        <assign-list v-if="b.ot==502"
            :tasks="b.tasks" :box="b" :parentTask="obj" :course="obj"
            @on-detail="$emit('on-detail', {event: $event, box: b})" @show-attach="$emit('show-attach', $event)"
            @on-reload="$emit('on-reload')"
          />

        <div v-if="b.forms.length">
          <form-list
            v-if="b.ot==116 || b.ot==389 || b.ot==503"
            :forms="b.forms"
            :box="b"
            @on-show-exam-result="$emit('on-show-exam-result', $event)"
            backTo="course"
          />
        </div>
        <div v-if="b.attaches.length">
          <div class v-for="(a,i) in b.attaches" :key="i+'_attaches'">{{a}}</div>
        </div>
      </div> -->
    <!-- </vue-custom-scrollbar> -->

    <b-modal v-model="modal.show" hide-header hide-footer centered size="lg">
      <div class="modal-header pd-y-20 pd-x-20 pd-sm-x-30">
        <a
          @click="modal.show = false"
          role="button"
          class="close pos-absolute t-15 r-15"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </a>
        <div class="media align-items-center">
          <span class="tx-color-03 d-none d-sm-block">
            <feather type="pen-tool" class="wd-40-f ht-40-f"></feather>
          </span>
          <div class="media-body mg-sm-l-20">
            <h4 class="tx-18 tx-sm-20 mg-b-2">
              {{ modal.ot == 389 ? "Судалгаа" : "Үнэлгээ" }}
            </h4>
            <p class="tx-13 tx-color-03 mg-b-0">
              {{
                modal.ot == 389
                  ? "Судалгаанд идэвхтэй хамрагдана уу. Баярлалаа"
                  : "Сургалтад үнэлгээ өгнө үү баярлалаа"
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30 ht-400">
        <template
          v-if="
          obj.boxes!=undefined && obj.boxes.length && obj.boxes.filter(x => x.ot == modal.ot && x.forms.length).length > 0
          "
        >
          <form-list
            v-for="(b, i) in obj.boxes.filter(
              x => x.ot == modal.ot && x.forms.length
            )"
            :forms="b.forms"
            :box="b"
            :key="i"
            @on-show-exam-result="$emit('on-show-exam-result', $event)"
            backTo="lesson"
            :fillOnModal="true"
            @on-modal-form-fill="modal.show=false; $emit('on-modal-form-fill', $event)"
          />
        </template>
        <template v-else>
          <div class="container d-flex justify-content-center ht-100p">
            <div
              class="mx-wd-300 wd-sm-450 ht-100p d-flex flex-column align-items-center justify-content-center pd-t-100"
            >
              <div class="wd-80p wd-sm-300 mg-b-15">
                <img src="assets/svg/boxempty.svg" alt="" class="img-fluid" />
              </div>
              <h4 class="tx-20 tx-sm-24 text-muted">Мэдээлэл хоосон байна</h4>
            </div>
          </div>
        </template>
      </div>
      <div class="modal-footer pd-x-20 pd-y-15"></div>
    </b-modal>

    <b-modal v-model="planModal" centered hide-header hide-footer content-class="rounded-20 pd-20">
      <div class="font-weight-bold tx-18 mg-b-20">
        7 Хоног тутмын сургалтын төлөвлөгөө засах
      </div>
      <div class="mg-b-30">
        Сургалтын төлөвлөгөө тавьсан суралцагчид хичээлээ дуусгах магадлал 75%-иар илүү байдаг. Та сургалтын төлөвлөгөөгөө үргэлж засах боломжтой. 
      </div>
      <div v-for="(intv, i) in intervals" :key="i">
        <div @click="intv.checked=!intv.checked" role="button" class="d-flex align-items-center bd bd-1 rounded-10 pd-10 mg-y-10">
          <div class="mg-r-10">
            <feather :type="`${intv.checked?'check-':''}circle`" class="tx-primary"></feather>
          </div>
          <div class="font-weight-bold">{{intv.title}}</div>
          <div class="mg-l-auto text-muted wd-100">{{intv.desc}}</div>
        </div>
      </div>
      <div class="text-center mg-t-20">
        <div class="mg-b-10">
          <button class="btn btn-white wd-200">Болих</button>
        </div>
        <div>
          <button @click="planModal= false" class="btn btn-primary wd-200">
            <div class="d-flex justify-content-center">
              <div class="mg-l-50">Хадгалах</div>
              <feather class="mg-l-auto" type="arrow-right"></feather>
            </div>
          </button>
        </div>

        <!-- <add-to-calendar-button
          name="Test-Event"
          startDate="2023-05-22"
          :options="['Apple','Google','Yahoo','iCal']"
        ></add-to-calendar-button> -->
        
      </div> 
    </b-modal>
  </div>
</template>

<script>

import TeacherDetail from "./teacherDetail.vue";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";
// import vueCustomScrollbar from "vue-custom-scrollbar";

// import AddToCalendarButton from 'add-to-calendar-button-vue';
import "element-ui/lib/theme-chalk/index.css";
import { MessageBox } from "element-ui";

export default {
  components: {
    TeacherDetail, // vueCustomScrollbar,
    courseCertificate: () => ({
      component: import("@/views/modules/lms/student/sections/courseCertificate.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    assignList: () => ({
      component: import("@/views/modules/lms/student/sections/assignList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    // teacherList: () => ({
    //   component: import("@/views/modules/lms/student/sections/teacherList.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    // lessonList: () => ({
    //   component: import("@/views/modules/lms/student/sections/lessonList.vue"),
    //   loading: AsyncLoading,
    //   error: AsyncLoadError,
    //   delay: 100,
    //   timeout: 5000
    // }),
    zoomList: () => ({
      component: import("@/views/modules/lms/student/sections/zoomList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    formList: () => ({
      component: import("@/views/modules/lms/student/sections/formList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    forumList: () => ({
      component: import("@/views/modules/lms/student/sections/forumList.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    })
  },
  props: {
    obj: {
      type: Object,
      default: () => {}
    },
    // cert: {
    //   type: Boolean,
    //   default: () => false
    // },
  },
  data() {
    return {
      planModal: false,
      intervals: [
        {checked: true, title: '7 Хоногт 2 өдөр сурна', desc: ''},
        {checked: false, title: '7 Хоногт 3 өдөр сурна', desc: 'Хамгийн Тохиромжтой'},
        {checked: false, title: '7 Хоногт 5 өдөр сурна', desc: ''},

      ],
      activeTab: 1,
      modal: {
        ot: null,
        show: false
      },
      firstLessonId: 0,
    };
  },
  mounted() {
    if(this.$route.params.bot==-7){
      this.activeTab= null;
    }
    //console.log('obj', this.obj);
    //console.log('mounted', this.obj.boxes.filter(x=>x.ot==114));
    // if(this.obj.boxes.filter(x=>x.ot==114 && x.tasks.length)){
    //   console.log('stp1', this.obj.boxes.filter(x=>x.ot==114)[0].tasks[0]);
    //   this.firstLessonId= this.obj.boxes.filter(x=>x.ot==114)[0].tasks[0]['id'];
    // }
  },
  methods: {
    changeTab(m) {
      this.activeTab = m;
    },
    getScrollHeight() {
      let mh = 170;
      if (screen.width <= 1024) {
        mh = 80;
      }
      if(this.$route.params.bot==-7){
        mh= 250;
      }
      return `calc(${window.innerHeight}px - ${mh}px);`;
    },
    showCourseSurvey(ot, box) {
      //console.log('forms', box);
      if(box!=undefined && box.forms!=undefined && box.forms.length==1){
        console.log('forms', this.obj.percent);
        if(this.obj.percent>=100){
          this.$emit('on-modal-form-fill', {id: box.forms[0]['id'], bid: box.id, bot: box.ot, prms: box.forms[0] });
        }else{
          MessageBox({
            confirmButtonText: "Хаах",
            type: 'warning',
            message: 'Хичээлүүдийг үзэж дуусгасны дараа сургалтад үнэлгээ өгөх боломжтой'
          })
        }
        //..@on-modal-form-fill="modal.show=false; $emit('on-modal-form-fill', $event)"
        // 
      }else{
        this.modal.ot = ot;
        this.modal.show = true;
      }
    },
    hasActiveZoom() {
      //console.log(this.obj.boxes.filter((x) => (x.ot == 493 || x.ot == 500 || x.ot == 516) && x.tasks.length));
      // this.obj.boxes
      //   .filter(
      //     x => (x.ot == 493 || x.ot == 500 || x.ot == 516) && x.tasks.length
      //   )
      //   .forEach(bx => {
      //     bx.tasks.forEach(t => {
      //       //if(t['dueStartDate']<=this.obj.date.now)
      //       //console.log(t.dueStartDate, this.obj.date.now)
      //     });
      //   });
      if(this.obj.boxes!=undefined && this.obj.boxes.length){
        let activezooms = this.obj.boxes.filter(
          x =>
            (x.ot == 493 || x.ot == 500 || x.ot == 516) &&
            x.tasks.length &&
            x.tasks.filter(
              t =>
                t["dueStartDate"] <= this.obj.date.now &&
                t["dueDate"] > this.obj.date.now
            ).length
        );
        if (activezooms.length) {
          return true;
        } else return false;
      }else{
        return false;
      }
      

      // let rv = "";
      // if (this.t["dueStartDate"] > this.nowDate) {
      //   rv = `<span class="badge badge-secondary">Хурал эхлэх | ${moment(
      //     this.t["dueStartDate"]
      //   ).format("MM-сар DD-н HHц:mmм")}</span>`;
      // } else {-
      //   if (this.t["dueDate"] > this.nowDate) {
      //     rv = '<span class="badge badge-warning">Хурал үргэлжилж байна</span>';
      //   } else {
      //     rv = `<span class="badge badge-success">Дууссан | ${moment(
      //       this.t["dueDate"]
      //     ).format("MM-сар DD-н HHц:mmм")}</span>`;
      //   }
      // }
      // return rv;
    }
  }
};
</script>

<style></style>
